<template>
  <div class="layout">
    <Sidebar @toggle-sidebar="toggleSidebar" />
    <div class="main-content" :class="{ 'sidebar-collapsed': isSidebarCollapsed }">
      <div class="page-header">
        <h1>Homepage Sections Management</h1>
        <div class="header-actions">
          <button class="create-button" @click="navigateToCreate">
            <i class="fas fa-plus"></i> Create New Section
          </button>
          <button class="refresh-button" @click="refreshSections" :disabled="isRefreshing">
            <i class="fas fa-sync-alt" :class="{ 'fa-spin': isRefreshing }"></i>
            {{ isRefreshing ? 'Refreshing...' : 'Refresh' }}
          </button>
        </div>
      </div>
      
      <HomepageSections ref="sectionsComponent" />
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import Sidebar from '@/components/Sidebar.vue';
import HomepageSections from '@/components/HomepageSections.vue';

export default {
  name: 'HomepageSectionsView',
  components: {
    Sidebar,
    HomepageSections
  },
  setup() {
    const router = useRouter();
    const sectionsComponent = ref(null);
    const isSidebarCollapsed = ref(false);
    const isRefreshing = ref(false);

    const toggleSidebar = () => {
      isSidebarCollapsed.value = !isSidebarCollapsed.value;
    };

    const navigateToCreate = () => {
      router.push('/homepage/create');
    };

    const refreshSections = async () => {
      if (isRefreshing.value) return;
      
      isRefreshing.value = true;
      try {
        if (sectionsComponent.value) {
          await sectionsComponent.value.fetchSections();
        }
      } finally {
        isRefreshing.value = false;
      }
    };

    return {
      sectionsComponent,
      isSidebarCollapsed,
      isRefreshing,
      toggleSidebar,
      navigateToCreate,
      refreshSections
    };
  }
};
</script>

<style scoped>
.layout {
  display: flex;
  min-height: 100vh;
}

.main-content {
  flex: 1;
  margin-left: 280px;
  transition: margin-left 0.3s ease;
  padding: 2rem;
}

.main-content.sidebar-collapsed {
  margin-left: 0;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #E5E7EB;
}

.page-header h1 {
  font-size: 1.8rem;
  color: #1F2937;
  margin: 0;
}

.header-actions {
  display: flex;
  gap: 1rem;
}

.create-button, 
.refresh-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.25rem;
  border-radius: 6px;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
}

.create-button {
  background: #3B82F6;
  color: white;
}

.create-button:hover {
  background: #2563EB;
}

.refresh-button {
  background: #F3F4F6;
  color: #4B5563;
}

.refresh-button:hover:not(:disabled) {
  background: #E5E7EB;
}

.refresh-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

@media (max-width: 768px) {
  .main-content {
    padding: 1rem;
  }
  
  .page-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }
  
  .header-actions {
    width: 100%;
  }
  
  .create-button, 
  .refresh-button {
    flex: 1;
    justify-content: center;
  }
}
</style> 